import { render, staticRenderFns } from "./ShowPromo.vue?vue&type=template&id=4ec35c12"
import script from "./ShowPromo.vue?vue&type=script&lang=js"
export * from "./ShowPromo.vue?vue&type=script&lang=js"
import style0 from "./ShowPromo.vue?vue&type=style&index=0&id=4ec35c12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports